// extracted by mini-css-extract-plugin
export default {"titleBlock":"MIv_ggt43aAzUTwWhnDh","iconRow":"w0DCARb0gaTdI2UsJTKJ","addNewPersonIcon":"SvLnVyezPWxcHhZ4t01S"};